import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import { Container } from 'reactstrap';
import styles from './styles.module.scss';
import Link from "next/link"
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import Caret from '../../public/site-assets/svg/caret.svg';
import AnchorLink from 'react-anchor-link-smooth-scroll'

export const ImageWithVideoBanner = ({
    className,
    image,
    content,
    videoLink,
    buttonTitle,
    buttonLink,
    pageAnchor
}) => {

    Fancybox.bind("[data-fancybox]");

    return (
        <section className={`${styles.root} ${className}`}>
            <Container className="py-4 py-md-5">
                <div className="position-relative p-md-5 p-4 rounded-3 overflow-hidden">
                    <div className="imageWrapper position-absolute">
                        <SourceFlowImage
                            src={image?.url ? image?.url : "/site-assets/images/what-we-do.jpg"}
                            size="1000x"
                            alt={image?.alt}
                            className="card-img rounded-0"
                        />
                    </div>
                    <div className="position-relative">
                        <div className="contentWrapper">
                            {content &&
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            }
                            {videoLink &&
                                <a
                                    className="fancyBox d-inline-block position-absolute"
                                    data-fancybox="ImageWithVideoBanner_fancybox"
                                    href={videoLink}
                                    aria-label="Play"
                                >
                                    <span className="play">
                                        <Caret />
                                    </span>
                                </a>
                            }
                        </div>
                        {buttonLink || pageAnchor &&
                            <div>
                                {pageAnchor ?
                                    <AnchorLink offset='80' href={`#${pageAnchor}`} className="primaryBtn no-arrow m-0">
                                        {buttonTitle}
                                    </AnchorLink>
                                :
                                    <Link href={`${buttonLink}`}>
                                        <a className="primaryBtn no-arrow m-0">
                                            {buttonTitle}
                                        </a>
                                    </Link>
                                }
                            </div>
                        }
                    </div>
                </div>
            </Container>
        </section>
    )
}

export default ImageWithVideoBanner;
